'use strict';
var base = require('./base');
var utils = require('pagedesigner/util/utils');
var zoomConfigs = require('../config/zoomConfigs');
var slickConfigs = require('org/config/slickConfigs');
var debounce = require('lodash/debounce');
var addToCartTooltip = require('./addToCartTooltip');
var colorSwatchTooltip = require('./colorSwatchTooltip');
var embroidery = require('org/product/embroidery');
var pdpCarousel = require('../components/pdpCarousel');
var shopSimilarStyles = require('../components/shopSimilarStyles');

// Deep link used by the "Write A Review" links in order history / order confirmation.
var WRITE_REVIEW_HASH = '#yotpo-write-review';
var YOTPO_WIDGET_SELECTOR = '#yotpo-reviews-top-div';
// Root element Yotpo renders once its widget app is mounted.
var YOTPO_APP_SELECTOR = '#yotpo-reviews-main-widget';
var YOTPO_WRITE_BTN_SELECTOR = '#yotpo-reviews-top-div button.yotpo-new-review-btn';
// Yotpo's review form dialog, used to confirm the form opened.
var YOTPO_MODAL_SELECTOR = '#yotpo-modal';
var YOTPO_POLL_INTERVAL_MS = 100;
// The widget can only open its form after the window `load` event, which is late on the PDP.
var YOTPO_READY_TIMEOUT_MS = 15000;
// Yotpo downloads the review form as a separate bundle when the button is clicked.
var YOTPO_MODAL_TIMEOUT_MS = 3000;
var YOTPO_MAX_OPEN_ATTEMPTS = 3;

/**
 * Setup navigation buttons (prev/next) for an Embla instance
 * @param {Object} emblaApi - Embla carousel instance
 * @param {HTMLElement} rootNode - The carousel wrapper element
 */
function setupEmblaNavigation(emblaApi, rootNode) {
    var prevBtn = rootNode.querySelector('.embla-button-prev');
    var nextBtn = rootNode.querySelector('.embla-button-next');

    var updateButtonStates = function () {
        if (!prevBtn || !nextBtn) return;

        var canScrollPrev = emblaApi.canScrollPrev();
        var canScrollNext = emblaApi.canScrollNext();

        if (canScrollPrev) {
            prevBtn.classList.remove('slick-disabled');
            prevBtn.removeAttribute('disabled');
        } else {
            prevBtn.classList.add('slick-disabled');
            prevBtn.setAttribute('disabled', 'disabled');
        }

        if (canScrollNext) {
            nextBtn.classList.remove('slick-disabled');
            nextBtn.removeAttribute('disabled');
        } else {
            nextBtn.classList.add('slick-disabled');
            nextBtn.setAttribute('disabled', 'disabled');
        }
    };

    if (prevBtn) {
        prevBtn.addEventListener('click', emblaApi.scrollPrev, false);
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', emblaApi.scrollNext, false);
    }

    // Update button states on select and init
    emblaApi.on('select', updateButtonStates);
    emblaApi.on('init', updateButtonStates);

    // Initial update
    updateButtonStates();
}

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

/**
 * Check if Canvas Supported
 * @returns {boolean} - canvas supported
 */
function isCanvasSupported() {
    var elem = document.createElement('canvas');
    return !!(elem.getContext && elem.getContext('2d'));
}

/**
 * Init Mobile Zoom
 * @param {string} slideClass - The class of the zoom slides
 */
function initMobileCanvasZoom(slideClass = '.zoom-slide') {
    $(slideClass).each(function () {
        var $slide = $(this).find('canvas');
        /* eslint-disable */
        var gesturableImg = new ImgTouchCanvas({
            canvas: $slide[0],
            path: $slide.data('url')
        });
        /* eslint-enable */
    });

    $('#mobileZoomImageCarouselModal').removeClass('is-resized');
}

/**
 * ReInit Mobile Zoom on resize
 * @param {string} slideClass - The class of the zoom slides
 */
function resizeListenerMobileCanvasZoom(slideClass = '.zoom-slide') {
    $(window).on('resize', debounce(function () {
        $('#mobileZoomImageCarouselModal').addClass('is-resized');
        if ($('#mobileZoomImageCarouselModal').hasClass('show')) {
            initMobileCanvasZoom(slideClass);
        }
    }, 500));
}

/**
 * Check if page is currently zoomed/scaled
 * @returns {boolean} - true if page scale is 1 (not zoomed), false otherwise
 */
function isPageScaleNormal() {
    return window.visualViewport ? window.visualViewport.scale === 1 : true;
}

/**
 * Intercept pinch gestures on images to open zoom modal instead of browser zoom
 */
function initPinchToZoom() {
    if (!utils.isMobile() || !document.elementFromPoint || !('ontouchstart' in window)) {
        return;
    }

    var state = { start: 0, pinching: false, target: null, triggered: false };

    var resetState = function () {
        state.pinching = false;
        state.start = 0;
        state.target = null;
        state.triggered = false;
    };

    var handleTouchStart = function (e) {
        if (!e || !e.target || !e.touches || e.touches.length !== 2) {
            return;
        }

        // Don't interfere if modal is open or page is already zoomed
        if ($('#mobileZoomImageCarouselModal').hasClass('show') || !isPageScaleNormal()) {
            return;
        }

        var target = e.target.closest && e.target.closest('.slide.zoom-hires');
        if (!target) return;

        var touch1 = e.touches[0];
        var touch2 = e.touches[1];

        if (!touch1 || !touch2 || typeof touch1.pageX !== 'number' || typeof touch2.pageX !== 'number') {
            return;
        }

        state.pinching = true;
        state.triggered = false;
        state.target = target;
        state.start = Math.hypot(touch2.pageX - touch1.pageX, touch2.pageY - touch1.pageY);
    };

    var handleTouchMove = function (e) {
        if (!e || !e.touches) return;

        // Don't interfere if modal is open or page is already zoomed
        if ($('#mobileZoomImageCarouselModal').hasClass('show') || !isPageScaleNormal()) {
            return;
        }

        var target = null;
        for (var i = 0; i < e.touches.length; i++) {
            var touch = e.touches[i];

            if (touch && typeof touch.clientX === 'number' && typeof touch.clientY === 'number') {
                var touchTarget = document.elementFromPoint(touch.clientX, touch.clientY);

                if (touchTarget && touchTarget.closest) {
                    var zoomSlide = touchTarget.closest('.slide.zoom-hires');
                    if (zoomSlide) {
                        target = zoomSlide;
                        break;
                    }
                }
            }
        }

        if (!target) return;

        if (e.touches.length === 2 && e.preventDefault) {
            e.preventDefault();
        }

        if (!state.pinching || state.triggered || !state.target) return;

        if (e.touches.length === 2) {
            var touch1 = e.touches[0];
            var touch2 = e.touches[1];

            if (!touch1 || !touch2 || typeof touch1.pageX !== 'number' || typeof touch2.pageX !== 'number') {
                resetState();
                return;
            }

            var current = Math.hypot(touch2.pageX - touch1.pageX, touch2.pageY - touch1.pageY);

            if (typeof current === 'number' && current > state.start * 1.05) {
                state.triggered = true;
                $(state.target).trigger('click');
                resetState();
            }
        }
    };

    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', resetState, { passive: true });
    document.addEventListener('touchcancel', resetState, { passive: true });
}

/**
 * Init PDP Zoom
 */
function initZoom() {
    $('body').on('click', '.slide.zoom-hires, .embla-slide.zoom-hires', function (e) {
        if ($(e.target).closest('.embla-pagination').length) return;

        var isDesktop = utils.mediaBreakpointUp('md');
        var $imageBlock = $(e.currentTarget);
        var $zoomModal = $('#mobileZoomImageCarouselModal');

        // Don't open modal if page is zoomed (mobile only)
        if (!isDesktop && !isPageScaleNormal()) {
            return;
        }

        if (isDesktop) {
            $zoomModal.find('.zoom-carousel.slick-initialized').slick('unslick');
            $zoomModal.find('.zoom-carousel').empty();

            if ($imageBlock.hasClass('zoom-initialized')) {
                $imageBlock.trigger('zoom.destroy');
                $imageBlock.removeClass('zoom-initialized');
                return;
            }

            var url = $imageBlock.data('zoom-url');
            if (url && url !== 'null') {
                // Start spinner while zoom image loads
                $imageBlock.spinner().start();

                var config = {
                    url: url,
                    callback: function () {
                        // Stop spinner when zoom image loaded
                        $imageBlock.spinner().stop();
                        $imageBlock.addClass('zoom-initialized');
                        var enterEvt = $.Event('mouseenter.zoom', { pageX: e.pageX, pageY: e.pageY }); // eslint-disable-line new-cap
                        $imageBlock.trigger(enterEvt);
                    }
                };
                config = $.extend({}, zoomConfigs, config);

                $imageBlock.zoom(config);
            }
        } else {
            $('.slide.zoom-hires, .embla-slide.zoom-hires').trigger('zoom.destroy');
            $imageBlock.removeClass('zoom-initialized');
            var imageIndex = $imageBlock.data('index') !== undefined ? $imageBlock.data('index') : $imageBlock.closest('.slick-slide').data('slick-index');
            var $pdpSlidesForIndex = $('.primary-images .embla-slide');
            var clickedSlideIndex = $pdpSlidesForIndex.index($imageBlock[0]);
            var storedPdpIndex;
            if (clickedSlideIndex >= 0) {
                storedPdpIndex = clickedSlideIndex;
            } else {
                var fallback = -1;
                if (pdpCarousel.default && pdpCarousel.default.getSelectedIndex) {
                    fallback = pdpCarousel.default.getSelectedIndex();
                }
                storedPdpIndex = fallback;
            }
            if (storedPdpIndex < 0 && typeof imageIndex === 'number') {
                storedPdpIndex = Math.max(0, imageIndex - 1);
            }
            var hadScrolled = window.scrollY > 0 || document.documentElement.scrollTop > 0;
            var scrollYBeforeModal = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

            // Zoom index = index in zoom carousel (excludes video). Use storedPdpIndex (Embla) to avoid race.
            var zoomStartIndex = 0;
            if (storedPdpIndex >= 0) {
                var $pdpSlides = $('.primary-images .embla-slide');
                var nonVideoCount = 0;
                for (var i = 0; i <= storedPdpIndex && i < $pdpSlides.length; i++) {
                    if (!$pdpSlides.eq(i).hasClass('video-slide')) {
                        nonVideoCount++;
                    }
                }
                zoomStartIndex = Math.max(0, nonVideoCount - 1);
            } else if (typeof imageIndex === 'number') {
                zoomStartIndex = Math.max(0, imageIndex - 1);
            }

            // Determine if using Embla or Slick based on primary images carousel
            var isUsingEmbla = $('.primary-images .embla-slide').length > 0;
            var $zoomContainer = isUsingEmbla ? $zoomModal.find('.embla-container') : $zoomModal.find('.zoom-carousel');

            if ($zoomContainer.find('.zoom-slide').length === 0) {
                var $slides = $('.primary-images .embla-slide');
                if ($slides.length === 0) {
                    $slides = $('.primary-images .slick-slide:not(.slick-cloned)');
                }
                $slides.each(function (index) {
                    var $imageSlide = $(this).hasClass('embla-slide') ? $(this) : $(this).find('.slide');

                    // Skip video slide for zoom carousel
                    if ($imageSlide.hasClass('video-slide')) {
                        return;
                    }

                    var mobileUrl = $imageSlide.data('zoom-url');
                    if (!mobileUrl || mobileUrl === 'null') {
                        mobileUrl = $imageSlide.find('img').attr('src');
                    }
                    var slideElement = '';
                    if (isCanvasSupported) {
                        slideElement = `<div class="${isUsingEmbla ? 'zoom embla-slide slide' : 'zoom-slide'}"><canvas id="image-slide-${index}" data-url="${mobileUrl}" style="width: 100%; height: 100%;"></canvas></div>`;
                    } else {
                        slideElement = `<div class="${isUsingEmbla ? 'zoom embla-slide slide ' : 'zoom-slide zoom-slide-fallback'}"><img id="image-slide-${index}" src="${mobileUrl}" class="h-100" /></div>`;
                    }

                    $zoomContainer.append(slideElement);
                });
            }

            var savedScrollY = scrollYBeforeModal;

            $zoomModal.modal('show');
            $zoomModal.spinner().start();

            // Remove any previous handlers to prevent stacking
            $zoomModal.off('shown.bs.modal').off('hide.bs.modal');

            $zoomModal.one('shown.bs.modal', function () {
                $('body').addClass('position-fixed').css('top', -savedScrollY + 'px');

                var viewport = utils.isMobile() && document.querySelector('meta[name=viewport]');
                if (viewport) {
                    var content = viewport.getAttribute('content');
                    viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
                    setTimeout(viewport.setAttribute.bind(viewport, 'content', content), 300);
                }

                if (isUsingEmbla) {
                    // Embla carousel initialization
                    var zoomCarouselNode = document.querySelector('.zoom-carousel');
                    var $zoomCarousel = $(zoomCarouselNode);
                    var emblaInstance = $zoomCarousel.data('embla-instance');

                    if (!emblaInstance) {
                        if (isCanvasSupported) {
                            initMobileCanvasZoom('.zoom.embla-slide');
                            resizeListenerMobileCanvasZoom('.zoom.embla-slide');
                        }

                        var zoomViewportNode = zoomCarouselNode.querySelector('.embla__viewport');
                        var zoomSlides = zoomCarouselNode.querySelectorAll('.embla-slide');

                        // Only initialize Embla if there's more than one slide
                        if (zoomSlides.length > 1 && zoomViewportNode) {
                            var EmblaCarousel = require('embla-carousel');
                            var emblaZoom = EmblaCarousel(zoomViewportNode, { // eslint-disable-line new-cap
                                watchDrag: false,
                                align: 'center',
                                slidesToScroll: 1,
                                startIndex: zoomStartIndex
                            });

                            // Setup navigation buttons
                            setupEmblaNavigation(emblaZoom, zoomCarouselNode);
                            zoomCarouselNode.classList.add('embla-initialized');
                        }
                    }
                } else {
                    // Slick slider initialization
                    if ($('.zoom-carousel.slick-initialized').length === 0) {
                        if (isCanvasSupported) {
                            initMobileCanvasZoom();
                            resizeListenerMobileCanvasZoom();
                        }

                        $('.zoom-carousel').slick(slickConfigs.zoomMobile);
                    }

                    $('.zoom-carousel').slick('slickGoTo', imageIndex, true);
                }

                if ($zoomModal.hasClass('is-resized')) {
                    setTimeout(function () {
                        initMobileCanvasZoom();
                    }, 100);
                }

                $zoomModal.spinner().stop();
            });
            $zoomModal.one('hide.bs.modal', function () {
                $('body').removeClass('position-fixed').css('top', '');
                if (savedScrollY > 0) {
                    window.scrollTo(0, savedScrollY);
                }
                if (pdpCarousel.default && pdpCarousel.default.setZoomModalCloseTime) {
                    pdpCarousel.default.setZoomModalCloseTime();
                }

                if (isUsingEmbla && storedPdpIndex >= 0 && pdpCarousel.default) {
                    var indexToRestore = storedPdpIndex;
                    var restoreSlide = function () {
                        if (pdpCarousel.default.reinitAtSlide) {
                            pdpCarousel.default.reinitAtSlide(indexToRestore);
                        } else if (pdpCarousel.default.scrollToSlide) {
                            pdpCarousel.default.scrollToSlide(indexToRestore, true);
                        }
                    };
                    if (hadScrolled) {
                        setTimeout(restoreSlide, 200);
                    } else {
                        requestAnimationFrame(function () {
                            requestAnimationFrame(restoreSlide);
                        });
                    }
                }

                if (isUsingEmbla) {
                    // Destroy Embla instance
                    var $zoomCarousel = $('.zoom-carousel');
                    var emblaInstance = $zoomCarousel.data('embla-instance');
                    if (emblaInstance) {
                        emblaInstance.destroy();
                        $zoomCarousel.removeData('embla-instance');
                        $zoomCarousel.removeClass('embla-initialized');
                    }
                    $zoomModal.find('.embla-container').empty();
                } else {
                    // Destroy Slick instance
                    if ($zoomModal.find('.zoom-carousel.slick-initialized').length > 0) {
                        $zoomModal.find('.zoom-carousel').slick('unslick');
                    }
                    $zoomModal.find('.zoom-carousel').empty();
                }
            });
        }
    });
}

/**
 * Defines wich column inside PDP will be sticky on window scroll
 */
function pdpStickyColumns() {
    var $imagesColumn = $('.primary-images');
    var $detailsColumn = $('.product-details-column');
    var $titleColumn = $('.product-title-block');
    var $pdpTitleWrap = $('#pdpTitleWrap');

    if (window.matchMedia('(min-width: 992px)').matches) {
        var imagesColumnHeight = $imagesColumn.height();
        var detailsColumnHeight = $detailsColumn.height();
        var titleColumnHeight = $titleColumn.height();
        var $stickyColumn = imagesColumnHeight > (detailsColumnHeight + titleColumnHeight) ? $detailsColumn : $imagesColumn;

        $detailsColumn.prepend($pdpTitleWrap);
        $stickyColumn.css({
            position: 'sticky',
            top: '80px'
        });
    } else {
        $titleColumn.append($pdpTitleWrap);
        $detailsColumn.removeAttr('style');
        $imagesColumn.removeAttr('style');
    }
}

/**
 * Make Add To Cart Sticky on Mobile PDP
 */
function stickyAddToCart() {
    var $button = $('.add-to-cart');
    var $buttonTop = $button.offset().top;
    var $drawer = $('.drawer-wrapper');
    var $drawerToggler = $('.drawer-toggler');
    var $buttomBottom;

    if ($drawer.length && $drawerToggler.length) {
        $buttomBottom = $drawerToggler.outerHeight() || 0;
    } else {
        $buttomBottom = 0;
    }

    $(window).scroll(function () {
        if ($(window).scrollTop() > $buttonTop) {
            $button.parent().addClass('is-sticky').css('bottom', $buttomBottom + 'px');
            $('footer .back-to-top').css('bottom', '146px');
        } else {
            $button.parent().removeClass('is-sticky').css('bottom', '');
            $('footer .back-to-top').css('bottom', '');
        }
    });
}

/**
 * Scroll the reviews widget into view, below the sticky header
 * @param {boolean} animated - true to animate the scroll, false to jump
 */
function scrollToYotpoReviews(animated) {
    var $reviews = $(YOTPO_WIDGET_SELECTOR);
    var offset = $reviews.length ? $reviews.offset() : null;

    if (!offset) {
        return;
    }

    var top = offset.top - ($('header.site-header').outerHeight() || 0);

    if (animated) {
        $('html, body').animate({ scrollTop: top }, 500);
    } else {
        $('html, body').scrollTop(top);
    }
}

/**
 * Poll for a condition until it is met or the timeout elapses
 * @param {Function} condition - Evaluated on every tick, polling stops on a truthy result
 * @param {number} timeoutMs - How long to keep polling before giving up
 * @param {Function} [onMet] - Called with the truthy result once the condition is met
 * @param {Function} [onTimeout] - Called instead when the condition is never met
 */
function pollUntil(condition, timeoutMs, onMet, onTimeout) {
    var deadline = Date.now() + timeoutMs;

    var tick = function () {
        var result = condition();

        if (result) {
            if (onMet) {
                onMet(result);
            }
            return;
        }

        if (Date.now() >= deadline) {
            if (onTimeout) {
                onTimeout();
            }
            return;
        }

        window.setTimeout(tick, YOTPO_POLL_INTERVAL_MS);
    };

    tick();
}

/**
 * Returns the Yotpo write-review button only once Yotpo is able to open its review form.
 * Yotpo renders the container holding the review form modal only after its internal
 * `pageLoaded` flag is set, and that flag is set from the window `load` event. Clicking the
 * button before then makes Yotpo dereference a modal container that does not exist yet and
 * throws "Cannot read properties of undefined (reading 'open')", leaving the form closed.
 * @returns {HTMLElement|null} The button when it is safe to click, otherwise null
 */
function getReadyYotpoWriteReviewButton() {
    if (document.readyState !== 'complete' || !document.querySelector(YOTPO_APP_SELECTOR)) {
        return null;
    }

    var button = document.querySelector(YOTPO_WRITE_BTN_SELECTOR);

    return button && button.offsetParent ? button : null;
}

/**
 * Click the Yotpo write-review button and confirm the review form actually opened,
 * retrying when it does not so a slow widget does not silently swallow the deep link.
 * @param {HTMLElement} button - The Yotpo write-review button
 * @param {number} attemptsLeft - Remaining click attempts
 */
function openYotpoReviewModal(button, attemptsLeft) {
    button.click();

    pollUntil(
        function () {
            return document.querySelector(YOTPO_MODAL_SELECTOR);
        },
        YOTPO_MODAL_TIMEOUT_MS,
        null,
        function () {
            var retryButton = attemptsLeft > 1 ? getReadyYotpoWriteReviewButton() : null;

            if (retryButton) {
                openYotpoReviewModal(retryButton, attemptsLeft - 1);
            }
        }
    );
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    init: function () {
        if (pdpCarousel && pdpCarousel.default) {
            pdpCarousel.default.init();
        }
        shopSimilarStyles.init();
        embroidery.initEmbroideryResumeWatcher();
        if (window.matchMedia('(max-width: 992px)').matches && window.location.hash === '#length') {
            let savedOffset = sessionStorage.getItem('pdpLengthOffset');
            let defaultOffset = 60;

            // Position the button where it was before the user navigated from the page
            if (savedOffset) {
                defaultOffset = parseInt(savedOffset, 10);
                sessionStorage.removeItem('pdpLengthOffset');
            }

            // Let the positioning happen after all js runs, as it might affect the DOM size
            setTimeout(() => {
                $('html')[0].scrollTop = $('.pdp-length-wrapper').offset().top - defaultOffset;
            }, 0);
        }

        if (window.matchMedia('(max-width: 576px)').matches) {
            stickyAddToCart();
        }
    },

    availability: base.availability,
    addToCart: base.addToCart,
    initSizeTooltips: base.initSizeTooltips(),
    initZoom: initZoom,
    initPinchToZoom: initPinchToZoom,
    addToCartTooltip: addToCartTooltip.init,
    colorSwatchTooltip: colorSwatchTooltip.init,

    stickyColumsInit: function () {
        var smBreakpointBool;
        pdpStickyColumns();

        // After variant has been selected and data is updated
        $('body').on('product:afterAttributeSelect', pdpStickyColumns);

        // On window resize
        $(window).on('resize', function () {
            if (window.matchMedia('(min-width: 992px)').matches) {
                if (smBreakpointBool || smBreakpointBool === undefined) {
                    pdpStickyColumns();
                    smBreakpointBool = false;
                }
            } else if (!window.matchMedia('(min-width: 992px)').matches) {
                if (!smBreakpointBool) {
                    pdpStickyColumns();
                    smBreakpointBool = true;
                }
            }
        });

        // When user interacts with the tabs inside the description area
        $('#productTabs [data-toggle="tab"]').on('shown.bs.tab', pdpStickyColumns);
    },

    scrollSizeChart: function () {
        $(document).on('click', '#scrollSizeChart', function () {
            var sizeChartDetails = $('.scroll-to-size-chart').offset().top - $('header.site-header').height();
            $('html, body').animate({
                scrollTop: sizeChartDetails
            }, 500);
            $('button[aria-controls="fit-and-size"]').removeClass('collapsed').attr('aria-expanded', 'true');
            $('#fit-and-size').addClass('show');
        });
    },

    scrollYotpoReviews: function () {
        $(document).on('click', '.link-scroll-to-reviews', function () {
            var yotpoReviewsDiv = $('#yotpo-reviews-top-div').offset().top - $('header.site-header').height();
            $('html, body').animate({
                scrollTop: yotpoReviewsDiv
            }, 500);
        });
    },

    openYotpoWriteReviewIfRequested: function () {
        if (window.location.hash !== WRITE_REVIEW_HASH || !$(YOTPO_WIDGET_SELECTOR).length) {
            return;
        }

        // The deep link is single use: reloading the PDP must not reopen the review form.
        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }

        // Guests reaching the PDP through a shared link cannot write a review.
        if (!$('.product-detail-review.registered').length) {
            return;
        }

        scrollToYotpoReviews(true);

        pollUntil(getReadyYotpoWriteReviewButton, YOTPO_READY_TIMEOUT_MS, function (button) {
            // The widget grows while it renders, which pushes the reviews out of view again.
            scrollToYotpoReviews(false);
            openYotpoReviewModal(button, YOTPO_MAX_OPEN_ATTEMPTS);
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            if ($(data).data('pagecontext') !== 'quickview') {
                $.spinner().start();
            }
        });
    },

    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('#quickViewModal.show').length === 0) {
                var upChargeTextArray = response.data.product.upChargeText;
                var upChargeText = '';
                for (var index = 0; index < upChargeTextArray.length; index++) {
                    upChargeText += upChargeTextArray[index] + '\n';
                }
                if ($('.product-detail>.bundle-items').length) {
                    response.container.data('pid', response.data.product.id);
                    response.container.find('.product-id').text(response.data.product.id);
                    response.container.find('.size-extra-price').text(upChargeText);
                } else if ($('.product-set-detail').eq(0).length) {
                    response.container.data('pid', response.data.product.id);
                    response.container.find('.product-id').text(response.data.product.id);
                    response.container.find('.size-extra-price').text(upChargeText);
                } else {
                    $('.product-id').text(response.data.product.id);
                    $('.size-extra-price').empty().append(upChargeText);
                    $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);

                    // Event rules defined on base.js
                    $(document.body).triggerHandler('globale:updatePrices');

                    // Preventing unnecessary reload/reconstruct of images / video when interacting with any attribute other than color
                    if (response.attributeType === 'color') {
                        var pdpImages = response.data.product.images.pdp;

                        if (pdpImages && pdpImages.length > 0) {
                            var $pdpCarousel = $('.product-carousel');
                            var $colorName = $pdpCarousel.parentsUntil('.product-detail').find('.select-color option.selected').data('color-name');

                            // Use embla updateSlides when the new carousel is active
                            if ($pdpCarousel.hasClass('embla-product-images') && pdpCarousel && pdpCarousel.default && pdpCarousel.default.updateSlides) {
                                pdpCarousel.default.updateSlides($pdpCarousel, response.data.product, $colorName);
                            } else {
                                // Fallback: rebuild slides for the old slick carousel
                                if ($pdpCarousel.hasClass('slick-initialized')) {
                                    $pdpCarousel.slick('unslick');
                                }

                                var $videoSlide = $pdpCarousel.find('.video-slide');
                                var $videoClone = $videoSlide.length ? $videoSlide.clone(true) : false;

                                var $badgeIcon = $pdpCarousel.find('[class*="icon-badge"]');
                                var $badgeIconClone = $badgeIcon.length ? $badgeIcon.clone(true) : false;

                                $pdpCarousel.empty();

                                $.each(pdpImages, function (i, element) {
                                    var zoomImageUlr = (response.data.product.imagesZoom && response.data.product.imagesZoom.pdpZoom[i]) ? response.data.product.imagesZoom.pdpZoom[i].url : false;
                                    var altCheck = element.alt ? element.alt : response.data.product.productName;
                                    var altTag = $colorName !== null ? altCheck + ' - ' + $colorName + ' - ' + (i + 1) : altCheck;

                                    $pdpCarousel.append(
                                        `<div class="slide position-relative ${zoomImageUlr ? 'zoom-hires' : 'zoom-disabled'}" data-zoom-url="${zoomImageUlr || ''}">
                                            <img src="${element.url}" class="slide-img" alt="${altTag}" />
                                        </div>`
                                    );

                                    if (i === 0 && $badgeIconClone) {
                                        $pdpCarousel.find('.slide').prepend($badgeIconClone);
                                    }
                                });

                                if ($videoClone) {
                                    $videoClone.appendTo($pdpCarousel);
                                }

                                $('.primary-images').toggleClass('pdp-single-image', (!$videoClone && pdpImages.length === 1));

                                $pdpCarousel.slick(slickConfigs.pdp);
                            }
                        }
                    }
                }

                base.initSizeTooltips();
            }
        });
    },

    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            if (response.product.availability.messagesTypes[0] === 'restriction') {
                $('div.availability-msg div', response.$productContainer).addClass('text-warning');
                $('div.restricted-hover', response.$productContainer).removeClass('d-none');
                $('button.add-to-cart', response.$productContainer).addClass('restricted');
            } else {
                $('div.availability-msg div', response.$productContainer).removeClass('text-warning');
                $('div.restricted-hover', response.$productContainer).addClass('d-none');
                $('button.add-to-cart', response.$productContainer).removeClass('restricted');
            }

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },

    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);
            var attrLength = response.product.variationAttributes.length;
            var hasSize = false;
            for (var i = 0; i < attrLength; i++) {
                var attr = response.product.variationAttributes[i].attributeId;
                if (attr === 'size') {
                    hasSize = true;
                }
            }
            if (response.product.availability.messagesTypes && response.product.availability.messagesTypes[0] !== 'restriction' && response.product.thresholdMessage.length > 0 && hasSize) {
                $('.product-threshold-message').empty().html(response.product.thresholdMessage).removeClass('d-none');
                $('.availability-msg').empty().addClass('d-none');
            } else {
                $('.availability-msg', response.$productContainer)
                    .empty().html(response.message).removeClass('d-none');
                $('.product-threshold-message').empty().addClass('d-none');
            }
            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },

    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    shopMultiColorsSizesEvents: base.shopMultiColorsSizesEvents,

    restrictedHover: function () {
        $('.restricted-hover').tooltip();
    },

    howToMeasure: function () {
        $(document).on('click', '.js-read-more-measure', function () {
            $('.how-to-measure').toggleClass('expanded');
        });
    },

    lengthButtons: function () {
        $(document.body).on('click', '.length-btn', function () {
            if ($(this).closest('#quickViewModal').length) {
                return;
            }
            if (!$(this).hasClass('active')) {
                let rect = $('.pdp-length-wrapper')[0].getBoundingClientRect();
                let offset = rect.y + 60; // Compensate for header

                // Save position of button in relation to screen
                sessionStorage.setItem('pdpLengthOffset', offset);
                $.spinner().start();
            }
        });
    },

    copyLinkToClipboard: function () {
        $('body').on('click', '.btn-copy-link', function (e) {
            e.preventDefault();
            navigator.clipboard.writeText(window.location.href);
            $(this).trigger('blur');

            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 1000);
        });
    },

    sendLinkByEmail: function () {
        $('body').on('click', '.bth-email-link', function (e) {
            e.preventDefault();
            var url = window.location.href;
            var subject = $(this).data('subject');
            var body = $(this).data('body');

            var email = 'mailto:?'
                + 'subject=' + encodeURIComponent(subject)
                + '&body=' + encodeURIComponent(body) + '\n \n'
                + url;

            window.location.href = email;
            $(this).trigger('blur');
        });
    },

    exponeaTracking: function () {
        // Track view_item on page load
        if (typeof exponea !== 'undefined' && window.exponeaProduct) { // eslint-disable-line no-undef
            exponea.track('view_item', window.exponeaProduct); // eslint-disable-line no-undef
        }

        // Update exponeaProduct on variation change
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (window.exponeaProduct && response.data && response.data.product) {
                var product = response.data.product;

                if (product.price && product.price.sales && product.price.sales.value) {
                    window.exponeaProduct.price = product.price.sales.value;
                }

                if (product.selectedColorName) {
                    window.exponeaProduct.color = product.selectedColorName;
                }

                if (product.id) {
                    window.exponeaProduct.id = product.id;
                }

                if (product.productName) {
                    window.exponeaProduct.name = product.productName;
                }

                if (product.brand) {
                    window.exponeaProduct.brand = product.brand;
                }

                if (product.gender) {
                    window.exponeaProduct.gender = product.gender;
                }
            }
        });
    },

    shareBtnMobile: function () {
        $('body').on('click', '.btn-share-mobile', function (e) {
            e.preventDefault();
            var title = $(this).data('title');

            if (navigator.share) {
                navigator.share({
                    title: title,
                    url: window.location.href
                })
                    .then(() =>
                        $(this).trigger('blur')
                    );
            } else {
                alert('Sharing is not supported on this browser.');
            }
        });
    }
};
